import { create, type StateCreator } from 'zustand'
import { devtools } from 'zustand/middleware'

import { zustandPlugin } from '@/modules/shared/openreplay'

type State = {
  /** Id kierowców zaznaczonych do wydruku (jako string - tak przychodzą z tabeli). */
  checkedDrivers: string[]
  /** Id pojazdów zaznaczonych do wydruku. */
  checkedVehicles: string[]
}

type Actions = {
  setCheckedDrivers: (checkedDrivers: string[]) => void
  setCheckedVehicles: (checkedVehicles: string[]) => void
  clearSelection: () => void
}

/** Ten sam cast co w pozostałych store'ach - patrz `genericErrorStore`. */
type StoreMutators = [['zustand/devtools', never]]

const trackedCreator = zustandPlugin as unknown as <T>(
  creator: StateCreator<T, StoreMutators, []>,
  name?: string,
) => StateCreator<T, StoreMutators, []>

/**
 * Zaznaczenie do wydruku, wcześniej `driverList.checkedDrivers` i
 * `vehicle.checkedVehicles`.
 *
 * Trzy ekrany wydruków (lista, ulubione, do wysłania) dzielą jedno zaznaczenie -
 * przejście między nimi ma je zachować - a `companySelection` czyści je przy zmianie
 * firmy. Dlatego to stan współdzielony, a nie stan pojedynczej strony.
 */
export const usePrintoutSelectionStore = create<State & Actions>()(
  devtools(
    trackedCreator(
      (set) => ({
        checkedDrivers: [],
        checkedVehicles: [],
        setCheckedDrivers: (checkedDrivers) =>
          set({ checkedDrivers }, false, 'setCheckedDrivers'),
        setCheckedVehicles: (checkedVehicles) =>
          set({ checkedVehicles }, false, 'setCheckedVehicles'),
        clearSelection: () =>
          set({ checkedDrivers: [], checkedVehicles: [] }, false, 'clear'),
      }),
      'printout-selection',
    ),
    { name: 'EasyTacho', store: 'printout-selection' },
  ),
)

/** Poza Reactem (stary `connect` przy wyborze firmy). */
export const clearPrintoutSelection = () =>
  usePrintoutSelectionStore.getState().clearSelection()
